import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import ArrowLink from "components/components/ArrowLink/ArrowLink";
import PageMeta from "components/components/Meta/PageMeta";
import AuthenticatedView from "components/components/Remit/AuthenticatedView/AuthenticatedView";
import PageHeader from "components/dataVisualization/dataPageComponents/PageHeader/PageHeader";
import React from "react";
import routeConstants from "utils/routeConstants";

const RemitSubmit: React.FC = () => (
  <>
    <PageMeta title="Submit REMIT" />
    <PageHeader
      title="Submit REMIT"
      pageDescription={
        <>
          <p>
            This page will allow market participants to submit REMIT (Regulation
            on wholesale Energy Markets Integrity and Transparency)
            notifications directly through Insights.
          </p>
        </>
      }
    />
    <section className="section pt-0">
      <div className="container">
        <div className="columns">
          <div className="column is-two-thirds">
            <AuthenticatedTemplate>
              <AuthenticatedView />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <div data-test-id="remit-unauthenticated-message">
                <p>You need to be logged in to submit REMIT notifications.</p>
                <br />
                <ArrowLink
                  to={routeConstants.irisLogin}
                  text="Login to Insights"
                  isInternalDestination={true}
                />
              </div>
            </UnauthenticatedTemplate>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default RemitSubmit;
